<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()" (tabledata)="getTableData()" (dataExportToExcel)="exportToExcel()"[displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [showSearch]="showSearch"[isExportDisable]="isExportDisable"[showExportBtn]="showExportBtn"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Map Group with User</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="groupSelected"
              (change)="onGroupChange($event.target.selectedIndex)">
        <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
      </select>
    </div>
<!--    <mat-slide-toggle (toggleChange)="slideChange()" [checked]="slideChecked"> <b class="blue"> Vendor Specific User</b></mat-slide-toggle>-->
    <div class="form-group">
      <input class="form-control radius-0 font-13" [(ngModel)]="userSelected" placeholder="Enter PS No">
    </div>
<!--    <mat-slide-toggle (toggleChange)="spocChange()"  [checked]="spocChecked"> <b class="blue"> Is a SPOC </b></mat-slide-toggle>-->

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>

<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">
      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter login ID"
                 [(ngModel)]="loginName">
      </div>
  </div>
  <div class="modal-footer pad-8">
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
  </ng-template>
<notifier-container></notifier-container>